import { Component } from '@angular/core';
import { Platform, IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from '@ngx-translate/core';
import { SocialSharing } from '@ionic-native/social-sharing';

import { PostProvider } from "../../providers/post/post";
import { LanguageProvider } from '../../providers/language/language';

import { PostFile } from '../../models/post-file.model';

import { PostCommentsPage } from "../post-comments/post-comments";
import { ProductDetailPage } from '../product-detail/product-detail';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

import { API_URL, APP_URL } from '../../providers/api-url';

@IonicPage()
@Component({
  selector: 'page-post-detail',
  templateUrl: 'post-detail.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class PostDetailPage {

  post: any;
  err: string;
  loading: boolean;

  canShare: boolean;

  dateLocale: string;

  constructor(private platform: Platform, private _sanitizer: DomSanitizer, public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public languageProvider: LanguageProvider, public postProvider: PostProvider, private socialSharing: SocialSharing) {
    this.dateLocale = this.languageProvider.getByLocale(this.translate.currentLang).code;
  }

  getPost() {
    this.loading = true;
  
    if(this.platform.is('core') || this.platform.is('mobileweb')) {
      this.canShare = false;
    } else {
      this.canShare = true;
    }

    this.postProvider.getByID(this.navParams.get('id'))
      .subscribe(
        post => {
          if (!post.average_rating) {
            post.average_rating = 0;
          }
          this.post = post;
        },
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  liked() {
    this.loading = true;
    this.postProvider.liked(this.post.id)
      .subscribe(
        post => {
          if (!post.average_rating) {
            post.average_rating = 0;
          }
          this.post = post;
        },
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  sharePost() {
    if (this.canShare) {
      this.socialSharing.shareWithOptions({
        message: this.post.excerpt,
        subject: this.post.name, 
        files: null, 
        url: APP_URL + '/#/post-details/' + this.post.id,
        chooserTitle: this.post.name
      }).then(share => {
        this.postProvider.shared(this.post.id)
        .subscribe(
          post => {}
        );
      }).catch(error => {
        this.getPost();
      });
    }
    
  }

  openProduct(productID: number) {
    this.navCtrl.push(ProductDetailPage, {
      id: productID
    });
  }

  openComments() {
    this.navCtrl.push(PostCommentsPage, {
      postId: this.post.id
    });
  }


  download(file: PostFile) {
    window.location.href = `${API_URL}/post-files/download/${file.id}`;
  }

  getBackground(img) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${img})`);
  }

  ionViewDidLoad() {
    this.getPost();
  }

}



// WEBPACK FOOTER //
// ./src/pages/post-detail/post-detail.ts